/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
// -------request start -------

export const PROMOTION_KEY = "HJM-P#canSelectPromotionPart&canSelectPromotion";
export const SUB_TOTAL_DETAIL_KEY = "core.trade-DM#cartView.subtotalDetail-M#subtotalDetailItem"; // 价格明细楼层key
export const REMOVE_KEY = "core.trade-DM#cartView.unusableProduct-M#defaultUnusableProductItem"; // 下架商品楼层key
export const PRODUCT_ITEM_CORE_KEY = "C-M#productItem&core";
export const PRODUCT_ITEM_BASIC_KEY = "C-M#productItem&basic";
export const PRODUCT_ITEM_EXTINFO_KEY = "HJM-M#cartProduct&extInfo";

export interface BodyParam {
  area?: string;
  refer?: number;
  client?: string;
  clientVersion?: string;
  userActionId?: string;
  verticalTag?: string;
  omittedDetail?: boolean;
  longitude?: string;
  latitude?: string;
  languageCode?: string;
  countryCode?: string;
  scene?: number;
  businessOrigin?: string;
  cartuuid?: string;
  extendParamMap?: {
    stock: boolean;
    tabId?: string;
  };
  operations?: Operations;
  skuId?: string;
  updateTags?: any;
}

export interface GetCartRequest {
  client?: string;
  clientVersion?: string;
  area?: string;
  body?: string;
  t?: number;
  appid?: string;
  bodyQuery?: any;
}

export interface OperationProduct {
  skuId?: string;
  num?: string;
  itemType?: number;
  id?: string;
  parentId?: string;
}

export interface OperationPromotion {
  num?: string;
  childList?: string[];
  id?: string;
  promotionId?: string;
  itemType?: string;
}

export interface Operations {
  products: OperationProduct[];
  promotions?: OperationPromotion[];
  updateTags?: any;
}
//  ------- request end -------

// ----- response start ---------
export interface CartType {
  namespace: string;
  version: string;
}

export interface TabMenuItemInfo {
  "C-M#tabMenuItem&core": {
    tabId: string;
    tabName: string;
    selected: boolean;
    skuUuids?: string[];
  };
}

interface ProductItemBasicInfo {
  skuName: string;
  imgUrl: string;
  thirdCId: string;
  price: string;
  firstCid: string;
  num: string;
  activeCheck: number;
  secondCid: string;
  isSetDefaultValue?: boolean;
}

interface MarkInfo {
  icon: string;
  text: string;
  type: number;
  richText: string;
  textColor: string;
  bgColor: string;
}

export interface CartProductExtInfo {
  enableCheck: number;
  productMarkInfo: {
    [key: string]: string;
  };
  itemType: number;
  totalPromoPrice: string;
  discount: string;
  maxBuyNum: string;
  revertPrice: string;
  donateSku: boolean;
  iconMap: {};
  specialId: string;
  includeCheckAll: boolean;
  originPriceShow: string;
  subtotalPrice: string;
  landedPrice: string;
  addCartTime: number;
  tabIdList: string[];
  limitBuy: boolean;
  skuUuid?: string;
  accountType: string;
  provideServiceFlag: number;
  rePrice: string;
  priceShow: string;
  productMarkSet: string[];
  weightDesc: string;
  cardSpecialId: number;
  propertyTagMap: {
    [key: string]: string;
  };
  brandId: string;
  currency: string;
}

interface ProductStockCoreInfo {
  remainNum: number;
  stockType: number;
  stockCodeDesc: string;
  stockCode: number;
}

interface ProductItemCoreInfo {
  skuId: string;
}

interface AbstractUnusableProductItemBasic {
  skuName: string;
  unusableType: string;
  imgUrl: string;
  itemType: number;
  price: string;
  num: string;
}

interface UnusableProductModelPropertyTag {
  color: string;
  size: string;
}

interface UnusableProductModelBasic {
  skuUuid: string;
  thirdCId: string;
  firstCid: string;
  weight: string;
  secondCid: string;
  propertyTag: UnusableProductModelPropertyTag;
}

interface AbstractUnusableProductItemCore {
  skuId: string;
}

export interface SubtotalDetailItemCore {
  adjustType: string;
  price: string;
  subItemName: string;
  name: string;
  type: string;
  seq: number;
}

export interface ProductItemInfo {
  partList?: PartList[];
  "C-M#productItem&basic"?: ProductItemBasicInfo;
  "HJM-M#cartProduct&extInfo"?: CartProductExtInfo;
  "C-M#productItem&core"?: ProductItemCoreInfo;
  "HJM-M#cartProduct&stockInfo"?: ProductStockCoreInfo;
  "C-M#abstractUnusableProductItem&basic"?: AbstractUnusableProductItemBasic;
  "HJM-M#unusableProductModel&basic"?: UnusableProductModelBasic;
  "C-M#abstractUnusableProductItem&core"?: AbstractUnusableProductItemCore;
}

export interface FreightBasicInfo {
  "HJM-M#basic&basic": {
    coudanTabs: string;
    displayType: number;
    coudanMsgRichText: string;
    coudanMsg: string;
    totalPriceNeed: string;
    freePostThreshold: string;
    isFreeFreight: boolean;
  };
}

interface GroupCheckboxInfo {
  enableCheck: number;
  activeCheck: number;
}

interface GroupAbstractInfo {
  groupId: number;
}

interface GroupCouponInfo {
  hasCoupon: boolean;
}

interface GroupDescriptionInfo {
  groupName: string;
  groupSubName: string;
  linkUrl: string;
  specialId: number;
}

interface GroupVendorInfo {
  vendorType: number;
  vendorId: number;
  vendorPrice: string;
}

interface GroupInfo {
  "HJM-M#groupModel&checkbox": GroupCheckboxInfo;
  "C-M#abstractGroupItem&core": GroupAbstractInfo;
  "HJM-M#groupModel&coupon": GroupCouponInfo;
  "HJM-M#groupModel&description": GroupDescriptionInfo;
  "HJM-M#groupModel&vendor": GroupVendorInfo;
}

export interface SubtotalDetailItemCoreInfo {
  "C-M#subtotalDetailItem&core": {
    adjustType: string;
    price: string;
    subItemName: string;
    name: string;
    type: string;
    seq: number;
  };
}

interface SubtotalNumberInfo {
  singleProductLimitNum: number;
  noneBookLimitNum: number;
  baiTiaoNoticeOn: number;
  preferentialSummary: {
    totalPrice: string;
  };
  baiTiaoSkuNum: number;
  selectedProductNum: string;
  bookLimitNum: number;
  productKindNum: number;
  productKindLimitNum: number;
  productNum: string;
  depreciateNum: string;
  selectedProductKindNum: number;
}

interface SubtotalOtherInfo {
  enableCheck: number;
  cartClearShow: boolean;
  configVersion: string;
  checkedCartState: number;
  activeCheck: number;
  imgDomain: string;
  cartAddClearGuide: number;
  settlementGroup: {
    [key: string]: number;
  };
}

interface SubtotalItemCoreInfo {
  totalPrice: string;
}

interface SubtotalPriceInfo {
  originTotalPriceShow: string;
  totalReprice: string;
  totalDiscount: string;
  originTotalPrice: string;
  priceShow: string;
  totalRealPrice: string;
  totalSavePrice: string;
  zeroOrderMsg: string; // 0元单文案
  isZeroOrder: string; // 是否0元单 1：0元单
}

export interface SubtotalInfo {
  "HJM-D#subtotal&number": SubtotalNumberInfo;
  "HJM-D#subtotal&other": SubtotalOtherInfo;
  "C-M#subtotalItem&core": SubtotalItemCoreInfo;
  "HJM-D#subtotal&price": SubtotalPriceInfo;
}

interface OfficialDocExtInfo {
  doc: string;
  title: string;
}

export interface PartList {
  type: {
    namespace: string;
    version: string;
  };
  info: {
    [key: string]: {
      mfmzFullRefundType: number;
      promoType: string;
      activeCheck: number;
      id: string;
      title: string;
    };
  };
}

interface Data {
  [key: string]:
    | { type: CartType; uuid: string; info: TabMenuItemInfo }
    | { type: CartType; uuid: string; info: ProductItemInfo; partList?: PartList[] }
    | { type: CartType; uuid: string; info: FreightBasicInfo }
    | { type: CartType; uuid: string; info: GroupInfo }
    | { type: CartType; uuid: string; info: SubtotalDetailItemCoreInfo }
    | { type: CartType; uuid: string; info: SubtotalInfo }
    | { type: CartType; uuid: string; info: OfficialDocExtInfo }
    | { imageDomain: string };
}

interface Hierarchy {
  [key: string]: string[];
}

export interface LocalInfo {
  currency: string;
  currencySymbol: string;
  languageCode: string;
  timezoneId: string;
}

export interface CartData {
  data: Data;
  hierarchy: Hierarchy;
  resultCode?: string;
  code?: string;
  localInfo: LocalInfo;
}
// ----- response end ---------

// ----- select type response start ---------
interface PriceViewItemPriceInfo {
  mainPrice: string;
  crossOffPrice: string;
  percentReductionDesc: string;
  percentReduction: string;
}

interface SlashBottomBasic {
  cykj: string;
}

interface ViewCommonItemCommonCore {
  stockState: number;
  venderId: string;
  skuStatus: string;
  spuId: string;
  availableNum: number;
  skuId: string;
}

interface ViewCommonItemCommonBasicProperty {
  delivery: string;
  pay_first: string;
  warranty: any;
  model: any;
  kjsp: any;
  sfhVAT: string;
}

interface ViewCommonItemCommonBasic {
  isXnzt: boolean;
  noSingleBuy: boolean;
  cartIcon: string;
  customerServiceGoUrl: string;
  shopText: string;
  property: ViewCommonItemCommonBasicProperty;
  isCanUsePoint: boolean;
  shopIcon: string;
  customerServiceIcon: string;
  isLoc: boolean;
  customerServiceText: string;
  cartText: string;
}

interface ViewSelectedItemCore {
  mainPrice: string;
  crossOffPrice: string;
  imageUrl: string;
  salesDesc: string;
}

export interface DimensionButton {
  // imgUrl: string;
  // stockState: number;
  // skuList: string[];
  // serialNumber: number;
  text: string;
  parentTitle?: string;
  key: string;
  label: string;
  serialNumber?: number;
  stockState?: number;
  hasStock?: boolean;
  imgUrl?: string;
  skuList: string[];
  checked?: boolean;
  // 是否禁用
  disabled?: boolean;
}
interface Dimension {
  dimensionNumber: number;
  dimTitle: string;
}

export interface DimensionButtonObject {
  "C-P#dimensionButton&dimensionButton": DimensionButton;
}
export interface ColorSizePart {
  buttonPartList: DimensionButtonObject[];
  "C-P#dimension&dimension": Dimension;
}
export interface TypeDetailInfo {
  priceModule?: {
    "C-M#priceViewItem&priceInfo": PriceViewItemPriceInfo;
  };
  commonModule?: {
    "VCYBB2C-D#slashBottom&basic": SlashBottomBasic;
    "C-M#viewCommonItem&commonCore": ViewCommonItemCommonCore;
    "C-M#viewCommonItem&commonBasic": ViewCommonItemCommonBasic;
  };
  selectedModule?: {
    "C-M#viewSelectedItem&core": ViewSelectedItemCore;
    colorSizePartList: ColorSizePart[];
  };
  masterMapModule?: any;
}

export interface TypeInfo {
  resultInfo: TypeDetailInfo;
  systemInfo: SystemInfo;
}
export interface SystemInfo {
  userAgentId: number;
  businessUnitId: any;
  callerAppName: null | string;
  callerDataCenter: null | string;
  callerIP: null | string;
  sdkVersion: null | string;
  language: null | string;
  businessType: null | string;
  buId: string;
  countryCode: string;
  languageCode: string;
  currencyCode: string;
  timezoneOffset: null | number;
  flowField: any;
  traceId: string;
}
// ----- select type response end ---------
